import { of, throwError } from 'rxjs';
// auth.interceptor.ts
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpClient } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { LoginService } from '../services/login.service';
import { environment } from '../../../environments/environment.development';
import { ConsentToAccessService } from '../../module/consent-to-access/consent-to-access.service';
import { Router } from '@angular/router';
import { ToastService } from '../services/toast.service';
//import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
      //private authService: AuthService
      private loginService: LoginService,
      private http: HttpClient,
      private consentManag:ConsentToAccessService,
      private router: Router,
      private toasterService: ToastService,
      ) {}

  private bypassUrls: string[] = [
    '.json',  // Skip all JSON files
    '.png',   // Skip all PNG images
    '.jpg',   // Skip all JPG images
    '.jpeg',  // Skip JPEG images
    '.svg',   // Skip SVG images
    '=json',  // Skip SVG images
    'loginOpenID', 'checkTokenValidity','GetRefreshAccessToken','backet/add','api.ipify.org',
    'GetVerifyAadhaarNumber','GetAadhaarDetailsOTP','GetVaultKey','FetchVideoSummary','FetchVideoTranscriptions','ChatVideo','ChatAIBot',
    'EKycProcess',
    'Get_Citizen_Attribute_Details',
    'GetProfile','GetUserProgress'
  ];

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //Skip .json URLs
    //if (request.url.endsWith('.json')) {
    //  return next.handle(request);
    //}

    if (this.bypassUrls.some(url => request.url.includes(url))) {
      return next.handle(request);
    }
    const existingData = sessionStorage.getItem('userData');
    const parsedData = existingData ? JSON.parse(existingData) : {};
    const accessToken = parsedData.access_token;
    //const userID = parsedData.CitizenID;
    const userID = parsedData.name;

    if (accessToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`,
          UserID : userID
        }
      });
    }

    return next.handle(request).pipe(switchMap(event => {
      if (event instanceof HttpResponse) {
        // Handle successful responses
      }
      return of(event);
    }), catchError(error => {
      //debugger;
      //if (error.status === 500 || error.status === 403 || error.status === 400 || error.status === 401) { //Unauthorized
      //if (error.status === 403 || error.status === 400 || error.status === 401) { //Unauthorized
      if (error.status === 403  || error.status === 400 || error.status === 401) { //Unauthorized
        const tokenPayload = {
          refresh_token: parsedData.refresh_token,
          authorizationCode: parsedData.authorizationCode
        };
        //return this.http.post(environment.AuthApi + '/auth/GetRefreshAccessToken',tokenPayload).pipe((switchMap(() => {
        return this.http.post(environment.AuthApi + '/auth/GetRefreshAccessToken',tokenPayload, { observe: 'response' }).pipe(
          switchMap((response: HttpResponse<any>) =>
            {
//
          //const newAccessToken = this.authService.getAccessToken();
          // if (newAccessToken) {
          //   request = request.clone({
          //     setHeaders: {
          //       Authorization: `Bearer ${newAccessToken}`
          //     }
          //   });
          //   return next.handle(request);
          // } else {
          //   this.authService.logout(); // Redirect to login
          // }
          //debugger;
          parsedData.idToken=response.body.idToken;
          if (response.body && response.body.error) {
            sessionStorage.removeItem('userData');
            this.consentManag.isLoggedIn = false;
            console.log(this.loginService.IDAMlogOut(parsedData.idToken));
             const existingData = sessionStorage.getItem('userData');

            this.loginService.IDAMlogOut(parsedData.idToken);
            //this.router.navigate(['/home/landing']);
            // If there's an error in the token refresh response
            return throwError(() => new Error(response.body.error));
          }
          if (response.body && !response.body.status) {
            sessionStorage.removeItem('userData');
            this.consentManag.isLoggedIn = false;
            console.log(this.loginService.IDAMlogOut(parsedData.idToken));
            this.loginService.IDAMlogOut(parsedData.idToken);
            //this.router.navigate(['/home/landing']);
            // If there's an error in the token refresh response
            return throwError(() => new Error(response.body.message));
          }
          if (response.ok == true) {
            var responsebody = response.body;
            const clonedRequest = request.clone({
              headers: request.headers.set('Authorization', `Bearer ${responsebody.access_token}`)
              .set('Userid', userID)
            });

               if (parsedData.hasOwnProperty("idToken")) {

              parsedData["idToken"] = responsebody.idToken;
            }
            if (parsedData.hasOwnProperty("access_token")) {

              parsedData["access_token"] = responsebody.access_token;
            }
            if (parsedData.hasOwnProperty("refresh_token")) {
              parsedData["refresh_token"] = responsebody.refresh_token;
            }
            if (parsedData.hasOwnProperty("expiretime")) {
              parsedData["expiretime"] = responsebody.expiretime;
              sessionStorage.setItem("_expiredTime", (Date.now() + responsebody.expiretime * 1000).toString());
              const refreshTokenTime = Date.now() + (responsebody.expiretime * 2) * 1000;
              sessionStorage.setItem("refreshTokenTime", refreshTokenTime.toString());
            }
            return next.handle(clonedRequest);
          } else {
            sessionStorage.removeItem('userData');
            this.consentManag.isLoggedIn = false;
            //console.log(this.loginService.IDAMlogOut(parsedData.idToken));
            this.loginService.IDAMlogOut(parsedData.idToken).subscribe((res: any) => {
              sessionStorage.removeItem('userData');
              //window.location.href = res;
            });
            sessionStorage.removeItem('userData');
            this.router.navigate(['/home/landing']);
            sessionStorage.removeItem('_expiredTime');
            this.toasterService.show("Your session has expired, Please Login again", { class: 'warning', title: '' });
            return throwError('Token is invalid. Please log in again.');
          }
        }));
      }else if(error.status === 500){
        this.toasterService.show("Please wait, we are loading right content for you.", {  class: 'danger',title: 'Warning', });
      }
      else if(error.status === 429){
        this.toasterService.show("Too Many Requests. Please wait for a moment and try again.", {  class: 'danger',title: 'Warning', });
      }
      else if(error.status === 0){
        this.loginService.IDAMlogOut(parsedData.idToken).subscribe((res: any) => {
          sessionStorage.removeItem('userData');
          //window.location.href = res;
        });
        sessionStorage.removeItem('userData');
        sessionStorage.removeItem('_expiredTime');
        sessionStorage.removeItem('language');
        // this.router.navigate(['/home/landing']);
        // this.toasterService.show("Your session has expired, Please Login again", { class: 'warning', title: '' });
        this.toasterService.show("Please wait, we are loading right content for you.", {  class: 'danger',title: 'Warning', });
      }
      else {
        if(this.consentManag.isLoggedIn == true){
        sessionStorage.removeItem('userData');
        this.consentManag.isLoggedIn = false;
        //console.log(this.loginService.IDAMlogOut(parsedData.idToken));
        this.loginService.IDAMlogOut(parsedData.idToken).subscribe((res: any) => {
          sessionStorage.removeItem('userData');
          //window.location.href = res;
        });
        sessionStorage.removeItem('userData');
        sessionStorage.removeItem('_expiredTime');
        sessionStorage.removeItem('language');
        //this.router.navigate(['/home/landing']);
        this.toasterService.show("Your session has expired, Please Login again", { class: 'warning', title: '' });
        return throwError('Token is invalid. Please log in again.');
      }
      }
      return throwError(error);
    }));
  }
}
